import { del, get, post, put } from './https';

export type HolidayType = 'PUBLIC_HOLIDAY' | 'FESTIVAL' | 'COMPANY_HOLIDAY';

export interface IHoliday {
  _id: string;
  date: string; // ISO
  type: HolidayType;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface HolidayBody {
  date: string; // YYYY-MM-DD
  type: HolidayType;
  description?: string;
}

export const HOLIDAY_TYPE_LABELS: Record<HolidayType, string> = {
  PUBLIC_HOLIDAY: 'Public Holiday',
  FESTIVAL: 'Festival',
  COMPANY_HOLIDAY: 'Company Holiday',
};

const POSTHoliday = async (body: HolidayBody): Promise<IHoliday> => {
  const result = await post('/api/v1/admin/holiday/create', body);

  if ((result.status === 200 || result.status === 201) && result.data?.status) {
    return result.data.data as IHoliday;
  }
  throw new Error(result.data?.message || 'Failed to create holiday');
};

const GETHolidays = async (): Promise<IHoliday[]> => {
  const result = await get('/api/v1/admin/holiday/list');

  if (result.status === 200 && result.data?.status) {
    return (result.data.data as IHoliday[]) || [];
  }
  throw new Error(result.data?.message || 'Failed to fetch holidays');
};

// Note: put/del in https.ts resolve to the response BODY, not the AxiosResponse.
const PUTHoliday = async (
  id: string,
  body: Partial<HolidayBody>,
): Promise<IHoliday> => {
  const result = await put(`/api/v1/admin/holiday/update/${id}`, body);

  if (result?.status && result?.data) {
    return result.data as IHoliday;
  }
  throw new Error(result?.message || 'Failed to update holiday');
};

const DELETEHoliday = async (id: string): Promise<void> => {
  const result = await del(`/api/v1/admin/holiday/delete/${id}`);

  if (!result?.status) {
    throw new Error(result?.message || 'Failed to delete holiday');
  }
};

export { POSTHoliday, GETHolidays, PUTHoliday, DELETEHoliday };
